import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistroventasComponent } from './registroventas/registroventas.component';
import { ConsultaComponent } from './consulta/consulta.component';
import { MonitoRegistroventasComponent } from './monito-registroventas/monito-registroventas.component';
import { MaestroUsuarioAddComponent } from './maestro-usuario-add/maestro-usuario-add.component';
import { MaestroUsuarioComponent } from './maestro-usuario/maestro-usuario.component';
import { MaestroUsuarioEditComponent } from './maestro-usuario-edit/maestro-usuario-edit.component';
import { ValidarAdmin } from './guards/validar-admin';
import { ReporteVentasComponent } from './reporte-ventas/reporte-ventas.component';
import { RegistroventacertificadaComponent } from './registroventacertificada/registroventacertificada.component';
import { ConsultarventacertificadaComponent } from './consultarventacertificada/consultarventacertificada.component';
import { MonitorVentasCertificadasComponent } from './monitor-ventas-certificadas/monitor-ventas-certificadas.component';
import { ReporteVentasCertificadasComponent } from './reporte-ventas-certificadas/reporte-ventas-certificadas.component';
import { ValidarAdminCerticadas } from './guards/validar-admin-certificado';
import { ValidarMarcaCertificada } from './guards/validar-marca-certificada';
import { ValidarMarca } from './guards/validar-marca';
import { ReporteclienteVentasCertificadasComponent } from './reportecliente-ventas-certificadas/reportecliente-ventas-certificadas.component';
import { ReporteVentasGraficommComponent } from './reporte-ventas-graficomm/reporte-ventas-graficomm.component';
import { ReporteVentasGeneralmmComponent } from './reporte-ventas-generalmm/reporte-ventas-generalmm.component';
import { ReporteVentasCcComponent } from './reporte-ventas-cc/reporte-ventas-cc.component';
import { ReporteVentasMarcasComponent } from './reporte-ventas-marcas/reporte-ventas-marcas.component';
import { ReporteVentasMarcaGralComponent } from './reporte-ventas-marcaGral/reporte-ventas-marcaGral.component';
import { ValidarAdminPermisos } from './guards/validar-admin-permisos';
//import { CondicionesMovimientosComponent } from './condiciones-movimientos/condiciones-movimientos.component';
//import { CondicionesMovimientoFormComponent } from './condiciones-movimiento-form/condiciones-movimiento-form.component';


const routes: Routes = [
  {
    path: '',
    data: {
      title: ''
    },
    children: [
      {
        path: 'RegistroVentas',
        component: RegistroventasComponent, canActivate: [ValidarMarca],
        data: {
          title: 'Registro de Ventas'
        }
      },
      {
        path: 'RegistroVentasCertificadas',
        component: RegistroventacertificadaComponent, canActivate: [ValidarMarcaCertificada],
        data: {
          title: 'Registro de Ventas Certificadas'
        }
      },
      {
        path: 'Consultarventacertificada',
        component: ConsultarventacertificadaComponent, canActivate: [ValidarMarcaCertificada],
        data: {
          title: 'Consulta de Ventas Certificadas'
        }
      },
      {
        path: 'ConsultaVentas',
        component: ConsultaComponent, canActivate: [ValidarMarca],
        data: {
          title: 'Consulta de Ventas'
        }
      },
      {
        path: 'MonitorVentas',
        component: MonitoRegistroventasComponent, canActivate: [ValidarMarca],
        data: {
          title: 'Monitor de Ventas'
        }
      },
      {
        path: 'MonitorVentasCertificadas',
        component: MonitorVentasCertificadasComponent, canActivate: [ValidarAdminCerticadas],
        data: {
          title: 'Monitor de Ventas Certificadas'
        }
      },

      {
        path: 'AdmUsuario',
        component: MaestroUsuarioComponent,
        canActivate: [ValidarAdminPermisos],
        data: {
          title: 'Administración de usuarios'
        }
      },
      { path: 'addUser', component: MaestroUsuarioAddComponent, canActivate: [ValidarAdminPermisos] },
      { path: 'editUser', component: MaestroUsuarioEditComponent, canActivate: [ValidarAdminPermisos] },
      {
        path: 'Reporte', component: ReporteVentasComponent, canActivate: [ValidarAdmin], data: {
          title: 'Reporte de ventas diarias'
        }
      },
      {
        path: 'ReporteVentasCertificadas', component: ReporteVentasCertificadasComponent, canActivate: [ValidarAdminCerticadas], data: {
          title: 'Reporte de ventas certificadas'
        }
      },
      {
        path: 'InformeVentasCertificadas', component: ReporteclienteVentasCertificadasComponent, canActivate: [ValidarAdminCerticadas], data: {
          title: 'Informe de ventas certificadas'
        }
      },
      // {
      //   path: 'CondicionesMovimientos', component: CondicionesMovimientosComponent,
      //      canActivate: [ValidarAdminCerticadas],
      //    data: {
      //     title: 'Condiciones de movimientos'
      //   }
      // },
      // {
      //   path: 'form/:action/:id', component: CondicionesMovimientoFormComponent, canActivate: [ValidarAdminCerticadas]
      // },
      {
        path: 'ReporteGeografico',
        component: ReporteVentasGraficommComponent, canActivate: [ValidarAdmin],
        data: {
          title: 'Reporte Geográfico'
        }
      },
      {
        path: 'CecoMM',
        component: ReporteVentasCcComponent, canActivate: [ValidarAdmin],
        data: {
          title: 'Centro Comercial'
        }
      },
      {
        path: 'GeneralMM',
        component: ReporteVentasGeneralmmComponent, canActivate: [ValidarAdmin],
        data: {
          title: 'General'
        }
      },
      {
        path: 'MarcaGral',
        component: ReporteVentasMarcaGralComponent, canActivate: [ValidarAdmin],
        data: {
          title: 'Reporte marca'
        }
      },
      {
        path: 'ReporteMarca',
        component: ReporteVentasMarcasComponent, canActivate: [ValidarMarca],
        data: {
          title: 'General'
        }
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistoVentasRoutingModule { }
